export const cookieBannerWasSeen = 'cookie-banner-was-seen';
export const cookieEnableAnalytics = 'cookie-enable-analytics';
export const cookieEnableTargeting = 'cookie-enable-targeting';

export const liLink = 'https://www.linkedin.com/company/phase1karma/';
export const fbLink = 'https://www.facebook.com/phase1karma/';
export const twLink = 'https://twitter.com/phase1karma';

export const scrollbarWidthProperty = '--scrollbar-width';
